export default "__VITE_ASSET__Bk16Qmnt__"